module.exports = __webpack_public_path__ + "img/tick.4048cf26.png";